export interface AuthSettings {
  backstageRecents: Options;
  backstageSort: BackstageSortOptions;
  dashboardQueue: Options;
  dashboardSort: Options;
  dashboardUserFilter: Options;
  dashboardUserStatus: DashboardUserStatusOptions;
  id: number | null;
  theme: ThemeOptions;
  tracking: Options;
  version: string | null;
}

export interface Partner {
  id: number;
  name: string;
}

export interface PBX {
  id: number;
  context: string;
}

export interface AuthStoreState {
  accessLevel: AccessLevel;
  createdDate: string;
  email: string;
  firstname: string;
  id: number | null;
  lastname: string;
  pbxes: PBX[];
  partner: Partner | null;
  settings: AuthSettings | Record<string, unknown>;
  updatedDate: string;
  authenticated: boolean;
  jwtToken: string;
}

export enum AccessLevel {
  ADMIN = 0,
  PARTNER = 1,
  CUSTOMER = 2,
  USER = 3,
  VIEWER = 4,
}

export enum Options {
  DISABLED = 0,
  ENABLED = 1,
}

export enum BackstageSortOptions {
  NAME = "name",
  CONTEXT = "context",
}

export enum DashboardUserStatusOptions {
  ACTIVE = "active",
  INACTIVE = "inactive",
  ALL = "all",
}

export enum ThemeOptions {
  SYSTEM = "system",
  LIGHT = "light",
  DARK = "dark",
}
